export const REGISTRATION = "REGISTRATION";
export const CLEAR_LOGIN = "CLEAR_LOGIN";
export const SET_EMAIL = "SET_EMAIL";
export const SET_PASSWORD = "SET_PASSWORD";
export const LOGIN = "LOGIN";
export const USER_DETAILS = "USER_DETAILS";
export const SUPERLOGIN = "SUPERLOGIN";
export const ADMINLOGIN = "ADMINLOGIN";
export const SET_NAME = "SET_NAME";
export const LOGOUT = "LOGOUT";
export const SIGNUP = "SIGNUP";
export const HANDLEDRAWER = "HANDLEDRAWER";
export const HANDLEDRAWER1 = "HANDLEDRAWER1";
export const OPEN_LOGIN_MODAL = "OPEN_LOGIN_MODAL";
export const SUCESSFUL = "SUCESSFUL";
export const VERIFY_OTP = "VERIFY_OTP";
export const IMAGE_UPLOAD = "IMAGE_UPLOAD";
export const ALL_HOTELS = "ALL_HOTELS";
export const SETALL = "SETALL";
export const TOURISMLOGIN = "TOURISMLOGIN";
export const SET_ADMIN_ID = "SET_ADMIN_ID";
export const SETACTIVE = "SETACTIVE";
export const ADMITCARD_DETAILS = "ADMITCARD_DETAILS";
